












































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

import { mapActions } from 'vuex';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';
import Button from '@/components/Button.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';

import { ActionTypes } from '@/store/disbursement';
import Accordion from '@/components/Accordion.vue';
import FormInput from '@/components/FormInput.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import ReportTable from './AccountStatementTable.vue';
import BalanceJumbotron from './components/BalanceJumbotron.vue';

@Component({
  components: {
    LayoutTitle,
    Button,
    LayoutContent,
    Tab,
    BalanceJumbotron,
    ReportTable,
    Accordion,
    SearchIcon,
    ExportIcon,
    SearchRow,
    SearchField,
    DatePicker,
    Select,
    FormInput,
  },
  methods: mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_BALANCE }),
})
export default class AccountStatement extends Vue {
  getBalance!: () => void;

  $refs!: {
    report: ReportTable;
  }

  searchOpen = false;

  date: DateRange = {
    startDate: null,
    endDate: null,
  }

  transactionTypeOptions = [
    { label: 'TRANSACTION', value: 'TRANSACTION' },
    { label: 'TOPUP', value: 'TOPUP' },
    { label: 'ALL TYPE', value: 'ALL' },
  ];

  transactionType: { label: string; value: string } | null = null;

  transactionId = '';

  statusOptions = [
    { label: 'SUCCESS', value: 'SUCCESS' },
    { label: 'PENDING', value: 'PENDING' },
    { label: 'REFUND', value: 'REFUND' },
    { label: 'CANCELED', value: 'CANCELED' },
    { label: 'ALL STATUS', value: 'ALL' },
  ];

  status: { label: string; value: string } | null = null;

  loadingExport = false;

  mounted() {
    this.getBalance();
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getTransaction(page: number, isExport = false) {
    const params = {
      date: this.date,
      status: this.status,
      type: this.transactionType,
      id: this.transactionId,
    };

    await this.$refs.report.getTransaction(params, page, isExport);
  }

  async exportTransaction() {
    const params = {
      date: this.date,
      status: this.status,
      type: this.transactionType,
      id: this.transactionId,
    };

    this.loadingExport = true;
    await this.$refs.report.export(params);
    this.loadingExport = false;
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.date === 'string') {
      const dates = params.date.split(',');
      this.date = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    }

    if (typeof params.status === 'string') {
      const status = {
        label: params.status,
        value: params.status,
      };

      this.status = status;
    } else {
      this.status = null;
    }

    if (typeof params.type === 'string') {
      const status = {
        label: params.type,
        value: params.type,
      };

      this.transactionType = status;
    } else {
      this.transactionType = null;
    }

    if (typeof params.id === 'string') {
      const { id } = params;
      this.transactionId = id;
    } else {
      this.transactionId = '';
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getTransaction(page);
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  search() {
    const date = this.date.startDate === null || this.date.endDate === null ? undefined : {
      start: dayjs(this.date.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.date.endDate).format('YYYY-MM-DD'),
    };

    this.$router.push({
      query: {
        date: date && `${date.start},${date.end}`,
        type: this.transactionType === null ? undefined : this.transactionType.value,
        status: this.status === null ? undefined : this.status.value,
        id: this.transactionId === '' ? undefined : this.transactionId,
      },
    });
  }

  cancel() {
    this.date = {
      startDate: null,
      endDate: null,
    };
    this.status = null;
    this.transactionType = null;
    this.transactionId = '';

    this.$router.push({
      query: {},
    });
  }
}
